import type { ApiErrorEnvelope } from "../types/index.js";

/**
 * Client-side mirror of the FastAPI error envelope (TRD-06 §6.13). Every
 * non-2xx response from the BE is normalised into this exception so apps
 * can catch a single error type regardless of underlying axios behaviour.
 */
export class ApiError extends Error {
  public readonly status: number;
  public readonly code: string;
  public readonly details?: Record<string, unknown>;

  constructor(
    message: string,
    options: {
      status: number;
      code: string;
      details?: Record<string, unknown>;
      cause?: unknown;
    },
  ) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause });
    this.name = "ApiError";
    this.status = options.status;
    this.code = options.code;
    this.details = options.details;
  }

  static fromResponse(status: number, body: unknown, fallbackMessage = "Request failed"): ApiError {
    const env = body as Partial<ApiErrorEnvelope> | null | undefined;
    const e = env?.error;
    return new ApiError(e?.message ?? fallbackMessage, {
      status,
      code: e?.code ?? "UNKNOWN",
      details: e?.details,
    });
  }
}
